<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FHnEUa/tc-custom/9781467728836.jpg?1701477035690" alt="This image is the cover for the book Emma's Easter, Holidays and Special Days"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Emma's Easter, Holidays and Special Days
      </h1>
      <p class="bookDescription body article font2">
        <p>Emma's family is celebrating Easter! Emma and her little brother hunt for Easter eggs and candy. They go to church. Then relatives come over for a big meal. Find out the different ways people celebrate this special day!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Bullard, Constanza Basaluzzo
      </h2>
      
      <p class="authorDescription body article"><B>Lisa Bullard</B> is the award-winning author of more than 60 books for children, including<I> You Can Write a Story: A Story-Writing Recipe for Kids</I>. She teaches writing classes at the Loft Literary Center and regularly visits schools to talk with students about story-writing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Millbrook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e1bab7a